module.exports = __webpack_public_path__ + "assets/img/projects_item8.ee56ddff.png";